<div class="international-test">
  <div class="progress-steps">
    <ng-container *ngFor="let categoryCO2e of testResult.categoryCO2e; let last = last">
      <div class="progress-step">
        <div class="progress-bar"></div>
        <div class="progress-bar__progress" [style.width]="calculateProgressBarWidth(categoryCO2e)"></div>
        <div
          class="progress-title"
          [ngClass]="{
            'progress-title--active': categoryCO2e.category.index <= categoryIndex
          }"
        >
          {{ categoryCO2e.category.title }}
        </div>
      </div>
    </ng-container>
  </div>

  <div class="question-component__container">
    <app-question class="question-component" [question]="currentQuestion" (answered)="onAnswered($event)">
    </app-question>
  </div>

  <div class="footer" *ngIf="content">
    <div class="footer__back">
      <button class="footer__back-button" (click)="previousQuestion()" *ngIf="!isFirstQuestion">
        <img class="footer__back-button-icon" src="/assets/icons/arrow-back.svg" alt="" />
        <span>{{ content?.fields.backButtonText }}</span>
      </button>
    </div>
    <div class="footer__chart">
      <div class="footer__chart-container">
        <app-chart *ngIf="chartData" [values]="chartData"></app-chart>
      </div>
    </div>
    <div class="footer__footprint">
      <div>
        <p class="footer__footprint-title">{{ content?.fields.yourCarbonFootprintText }}</p>
        <p class="footer__footprint-number">
          &nbsp;
          <strong>{{ testResult.co2e | round: -1 }}</strong> kg&nbsp;CO₂e
        </p>
      </div>
    </div>
  </div>
</div>
